

























































































  import SectionFormulaireVue from '@/commun/components/champ-formulaire/section-formulaire/section-formulaire.vue';
  import { DateUtils } from '@/commun/utils/date-utils';
  import Vue, { PropType } from 'vue';
  import { DemandeDocument } from '@/domain/models/demande-document';
  import FileSaver from 'file-saver';

  export default Vue.extend({
    name: 'SectionDocuments',
    components: {
      SectionFormulaireVue,
    },
    props: {
      demandeDocumentExistants: {
        type: Array as PropType<Array<DemandeDocument>>,
        default: () => [],
      },
      accept: {
        type: Array as PropType<Array<string>>,
        default: () => [
          'doc',
          'docx',
          'pdf',
          'xls',
          'xlsx',
          'png',
          'jpg',
          'jpeg',
          'DOC',
          'DOCX',
          'PDF',
          'XLS',
          'XLXS',
          'PNG',
          'JPG',
          'JPEG',
        ],
      },
      taillMaxParFichierEnBytes: {
        type: Number,
        default: 10485760,
      },
      nombreFichiersMaximum: {
        type: Number,
        default: 50,
      },
    },
    data: () => ({
      nouveauxFichiers: new Array<File>(0),
      messagesAvertissement: new Array<string>(0),
    }),
    methods: {
      async ouvrirFichier(d: DemandeDocument): Promise<void> {
        const blob = await this.$store.dispatch(
          'telechargerDemandeDocumentFichier',
          {
            idDemande: d.idDemande,
            idDocument: d.idDocument,
          }
        );
        FileSaver.saveAs(blob, d.nomFichier);
      },

      supprimerTout(): void {
        this.nouveauxFichiers = new Array<File>(0);
        this.$emit('supprimer-all-documents');
      },
      emitChange(): void {
        this.$emit('change', this.nouveauxFichiers);
      },
      onAjouter(): void {
        (this.$refs.input as HTMLInputElement).click();
      },
      onChange(fileList: FileList): void {
        const files = [
          this.filterFichiersExtensionsRefusees,
          this.filtrerDocumentsTropVolumineux,
          this.enleverFichiersDeTrop,
        ].reduce((acc, cur) => cur(acc), Array.from(fileList));

        this.nouveauxFichiers = this.nouveauxFichiers.concat(
          files.filter(
            (f) => !this.nouveauxFichiers.map((nf) => nf.name).includes(f.name)
          )
        );
        this.emitChange();
      },
      onSupprimerNouveauFichier(index: number): void {
        this.nouveauxFichiers.splice(index, 1);
        this.emitChange();
      },
      filterFichiersExtensionsRefusees(files: File[]): File[] {
        return files.filter((d) => {
          const accepte = this.accept.some((a) => d.name.endsWith(a));

          if (!accepte) {
            this.messagesAvertissement.push(
              `${d.name}: ${this.$i18n
                .t(
                  'demande.formulaires.champs.documents.avertissement-extension'
                )
                .toString()}`
            );
          }

          return accepte;
        });
      },
      filtrerDocumentsTropVolumineux(files: File[]): File[] {
        return files.filter((d) => {
          const accepte = d.size <= this.taillMaxParFichierEnBytes;

          if (!accepte) {
            this.messagesAvertissement.push(
              `${d.name}: ${this.$i18n
                .t('demande.formulaires.champs.documents.avertissement-taille')
                .toString()}`
            );
          }

          return accepte;
        });
      },
      enleverFichiersDeTrop(files: File[]): File[] {
        const copy = files.slice();
        const nombreDeFichiersExistants =
          this.nouveauxFichiers.length + this.demandeDocumentExistants.length;

        files = files.slice(
          0,
          this.nombreFichiersMaximum - nombreDeFichiersExistants
        );

        copy
          .slice(this.nombreFichiersMaximum - nombreDeFichiersExistants)
          .forEach((d) => {
            this.messagesAvertissement.push(
              `${d.name}: ${this.$i18n
                .t('demande.formulaires.champs.documents.avertissement-nombre')
                .toString()}`
            );
          });

        return files;
      },
      onAlertChange(value: boolean) {
        if (!value) this.messagesAvertissement = [];
      },
      dateDepotFormatee(horodateDepot: string): string {
        return DateUtils.formaterIntlDateTime(horodateDepot);
      },
    },
  });
